<template>
  <div class="leftside-menu">
    <!-- Brand Logo Light -->
    <router-link to="/" class="logo logo-light">
      <span class="logo-lg">
        <img src="@/assets/images/logo.svg" alt="logo" />
      </span>
      <span class="logo-sm">
        <img src="@/assets/images/logo.svg" alt="small logo" />
      </span>
    </router-link>

    <!-- Brand Logo Dark -->
    <router-link to="/" class="logo logo-dark">
      <span class="logo-lg">
        <img src="@/assets/images/logo.svg" alt="dark logo" />
      </span>
      <span class="logo-sm">
        <img src="@/assets/images/logo.svg" alt="small logo" />
      </span>
    </router-link>

    <!-- Sidebar Hover Menu Toggle Button -->
    <div class="button-sm-hover" data-bs-toggle="tooltip" data-bs-placement="right" title="Show Full Sidebar">
      <i class="ri-checkbox-blank-circle-line align-middle"></i>
    </div>

    <!-- Full Sidebar Menu Close Button -->
    <div class="button-close-fullsidebar">
      <i class="ri-close-fill align-middle"></i>
    </div>

    <!-- Sidebar -left -->
    <div id="leftside-menu-container" class="h-100" data-simplebar>
      <!--- Sidemenu -->
      <ul class="side-nav">
        <li class="side-nav-title">Navigation</li>

        <li class="side-nav-item cursor-pointer" role="option">
          <a v-b-toggle.sidebarDashboards href="#" class="side-nav-link">
            <i class="uil-home-alt"></i>
            <span> Dashboard </span>
          </a>
          <b-collapse id="sidebarDashboards" class="b-collapse" visible>
            <ul class="side-nav-second-level">
              <li><router-link to="/" class="side-nav-link-ref">NEW</router-link></li>
              <li><router-link to="/shipments" class="side-nav-link-ref">Shipments</router-link></li>
              <li><router-link to="/assignments" class="side-nav-link-ref">Assignments</router-link></li>
              <li><router-link to="/customers" class="side-nav-link-ref">Customers</router-link></li>
            </ul>
          </b-collapse>
        </li>
      </ul>
      <div class="clearfix"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'

export default defineComponent({
  setup() {
    const activateMenuItems = () => {
      const links = document.getElementsByClassName('side-nav-link-ref')
      let menuItemEl: Element | null = null
      for (let i = 0; i < links.length; i++) {
        if (window.location.pathname === links[i]?.getAttribute('href')) {
          menuItemEl = links[i] || null
          break
        }
      }

      if (menuItemEl) {
        const parentEl = menuItemEl.parentElement
        menuItemEl.classList.add('active')
        parentEl?.classList.add('menuitem-active')

        if (parentEl?.parentElement?.parentElement?.parentElement?.parentElement?.parentElement?.parentElement) {
          // level 2 nested
          parentEl.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.classList.add(
            'menuitem-active',
          )
          parentEl.parentElement.parentElement.parentElement.classList.add('menuitem-active')
          parentEl.parentElement.parentElement.parentElement.children[0]?.classList.add('active')
          parentEl.parentElement.parentElement.parentElement.parentElement.parentElement.classList.add('show')
          parentEl.parentElement.parentElement.classList.add('show')
        } else {
          // level 1 nested
          parentEl?.parentElement?.parentElement?.parentElement?.classList.add('menuitem-active')
          parentEl?.parentElement?.parentElement?.classList.add('show')
        }
      }
    }

    const initSidenav = () => {
      setTimeout(() => {
        const activatedItem = document.querySelector<HTMLElement>('.side-nav-link-ref.active')
        if (activatedItem) {
          const menuContent = document.querySelector('#leftside-menu-container .simplebar-content-wrapper')
          const offset = activatedItem.offsetTop - 300
          if (menuContent && offset > 100) {
            scrollTo(menuContent, offset, 600)
          }
        }
      }, 200)
    }

    const easeInOutQuad = (t: number, b: number, c: number, d: number): number => {
      t /= d / 2
      if (t < 1) return (c / 2) * t * t + b
      t--
      return (-c / 2) * (t * (t - 2) - 1) + b
    }

    const scrollTo = (element: Element, to: number, duration: number) => {
      const start = element.scrollTop
      const change = to - start
      let currentTime = 0
      const increment = 20

      const animateScroll = () => {
        currentTime += increment
        element.scrollTop = easeInOutQuad(currentTime, start, change, duration)
        if (currentTime < duration) {
          setTimeout(animateScroll, increment)
        }
      }
      animateScroll()
    }

    onMounted(() => {
      activateMenuItems()
      initSidenav()
    })

    return {}
  },
})
</script>
